<div class="rd-widget table-widget widget-{{widgetConfig?.widgetId}}" *ngIf="widgetData">
  <table data-id="widgetExpertSurvey" class="widget-small widgetExpertSurveyClass cellspacing-0 cellpadding-0" style="height: 100%;" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="33" class="widget-grid-column widget-header-red" style="text-align: start;">
            <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Expert Survey</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>

    <tbody>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="dark-grey-line">
          <td colspan="10">
            {{'expertSurvey.usExpertSurveySource' | rdTranslate}}
          </td>
          <td colspan="10">
            {{'expertSurvey.usExpertSurveyCapRate' | rdTranslate}}
          </td>
          <td colspan="13">
            {{'expertSurvey.usExpertSurveyComments' | rdTranslate}}
          </td>
        </tr>
      </dynamic-growth-row>
      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <dynamic-growth-row [row]="i + 2" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="10">
              <widget-value [align]="'left'">{{entry.usExpertSurveySource}}</widget-value>
            </td>
            <td colspan="10">
              <widget-value [align]="'left'">{{entry.usExpertSurveyCapRate}}</widget-value>
            </td>
            <td colspan="13">
              <widget-value [align]="'left'">{{entry.usExpertSurveyComments}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
    </tbody>
  </table>
</div>
